import { useL10n } from '@uplift/hooks';
import { DateOfBirthInput } from '@uplift/ui-v2';
import { useSettingsStyles } from '../../../styles';

export const DobForm = () => {
  const { classes } = useSettingsStyles();
  const l10n = useL10n();

  return (
    <div>
      <DateOfBirthInput
        name="dob"
        inputClasses={{ root: classes.maxWidth140 }} // maxWidth on input so that error message width isn't affected
        helperText={l10n.accountSettings.dateOfBirthTip}
        id="dob"
      />
    </div>
  );
};
